module.exports = __webpack_public_path__ + "static/media/paypal_icon.9e01fd9a.png";